module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./StudioMsgView.js"));
	}, "StudioMsgView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=StudioMsgView!./src/pages/Register/StudioMsg/StudioMsgView.js
// module id = 825
// module chunks = 438